import { createAction } from '@reduxjs/toolkit'
import { MESSAGES_REQUEST, MESSAGES_SUCCESS, MESSAGES_ERROR } from './actionTypes'
import { IFile } from '../../../../types'

export const messagesRequest = createAction(MESSAGES_REQUEST)
export const messagesSuccess = createAction<IFile[]>(MESSAGES_SUCCESS)
export const messagesError = createAction<any>(MESSAGES_ERROR)
